/**
 * Ohlásenie ťahu. Kto je na rade, hovorí aj horná lišta a dýchajúce figúrky,
 * ale zmenu ťahu treba **všimnúť si** — hlavne v online hre, kde sa medzitým
 * pozeráš inam. Pás preletí cez dosku a zmizne; nič neblokuje.
 */

import type { TurnShow } from '../game/useStage.js';

interface Props {
  show: TurnShow;
  name: string;
  you: boolean;
}

export function TurnBanner({ show, name, you }: Props) {
  return (
    <div className={`turnBanner turnBanner--p${show.player}`} key={show.key} role="status">
      <div className="turnBanner__band">
        <span className="turnBanner__turn">Ťah {show.turnNumber}</span>
        <span className="turnBanner__who">{you ? 'Si na ťahu' : name}</span>
      </div>
    </div>
  );
}
